import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Star05 = function Star05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 2-1.3015 5.206c-.254 1.0158-.3809 1.5238-.6454 1.937a3 3 0 0 1-.91.9101c-.4133.2645-.9213.3914-1.9371.6454L2 12l5.206 1.3015c1.0158.254 1.5238.3809 1.937.6454.3657.2339.6761.5444.9101.91.2645.4133.3914.9213.6454 1.9371L12 22l1.3015-5.206c.254-1.0158.3809-1.5238.6454-1.9371a3 3 0 0 1 .91-.91c.4133-.2645.9213-.3914 1.9371-.6454L22 12l-5.206-1.3015c-1.0158-.254-1.5238-.3809-1.9371-.6454a3 3 0 0 1-.91-.91c-.2645-.4133-.3914-.9213-.6454-1.9371z"
    })
  }));
};
export default Star05;